<template>
  <div class="emoticons-button">
    <i @click.stop="toggleEmoji"><v-icon name="regular/smile" scale="1.1" /></i>
    <ul class="emoji-list" :class="[openedEmoji ? 'visible' : 'invisible']" v-clickaway="hideEmoji">
<!--             <li>
        <h4>Frequently Used</h4>
        <div class="emoji-items"><img :src="emojiList['wink']" alt="wink" class="wink emoji  regular"></div>
        <div class="emoji-items"><img :src="emojiList['tongue-out']" alt="tongue-out" class="tongue-out emoji regular"></div>
        <div class="emoji-items"><img :src="emojiList['tired']" alt="tired" class="tired emoji regular"></div>
      </li> -->
      <li>
        <h4>{{ $t('all_emojis') }}</h4>
        <div class="emoji-items" v-for="(emoji, index) in emojiList" @click="insertEmoji(emoji)" :key="index">
          <span :alt="emoji" class="emoji regular">
            <i class="icon-emo" :class="emoji.replace('_', '-')"></i>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import * as utils from '../utils'

export default {
  name: 'emoji',
  data () {
    return {
      openedEmoji: false,
      emojiList: utils.EMOJI_LIST
    }
  },
  methods: {
    toggleEmoji () {
      utils.log('toggle Emoji')
      this.openedEmoji = !this.openedEmoji
    },

    hideEmoji () {
      this.openedEmoji = false
    },

    insertEmoji (name) {
      utils.log('insert Emoji:', name)
      this.$parent.insertEmoji(name)
      this.hideEmoji()
    }
  }
}
</script>
